import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { flightSearchesStore } from 'widgets/avia'
import { ListResultsSearch } from 'widgets/avia/search-result-avia'

import findTicketStore from 'entities/ticket/models/find-ticket/find-ticket-store'

const ListResultsSearchPage = observer(() => {
  const formSearchTicket = toJS(findTicketStore.formFindTicket)

  const navigate = useNavigate()

  useEffect(() => {
    flightSearchesStore.setSearchesNeedRefresh(true)

    const direction = formSearchTicket?.directions?.[0]

    !direction?.date && navigate(RoutingPaths.path())
  }, [])

  return <ListResultsSearch formSearchAvia={formSearchTicket} />
})

export default ListResultsSearchPage
